<script lang="ts" setup>
import ErrorMessage from '@/corePagesModule/components/ErrorMessage.vue';

// v-modelでバインドする
const props = withDefaults(
  defineProps<{
    modelValue: string;
    label: string;
    isError?: boolean;
    errorMessage?: string;
    placeholder?: string;
    disabled?: boolean;
    errorMessagePosition?: 'top' | 'bottom';
  }>(),
  { errorMessage: '', placeholder: '', errorMessagePosition: 'top' }
);

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void;
}>();

/**
 * 入力イベントを親コンポーネントに通知します。
 * @param event - 入力イベント
 */
const onInput = (event: Event) => {
  emit('update:modelValue', (event.target as HTMLInputElement).value);
};
</script>
<template>
  <div>
    <div class="text-input__label">
      <label v-if="label !== ''" :for="`unmanaged-business-${label}`" class="text-input__label-text">{{ label }}</label>
      <ErrorMessage v-if="props.errorMessagePosition === 'top'" :is-error="isError" :error-message="errorMessage" />
    </div>
    <input
      :id="`unmanaged-business-${label}`"
      :disabled="props.disabled"
      class="text-input"
      :class="{ 'text-input__is-error': isError }"
      type="text"
      :value="props.modelValue"
      :placeholder="placeholder"
      @input="onInput"
    />
    <ErrorMessage v-if="props.errorMessagePosition === 'bottom'" :is-error="isError" :error-message="errorMessage" />
  </div>
</template>
<style lang="scss" scoped>
.text-input {
  padding: 7px 8px;
  background-color: $semanticWhite;
  height: 38px;

  font-family: Noto Sans JP;
  font-size: 14px;
  font-weight: 400;
  line-height: 20.27px;
  text-align: left;
  color: $textDefault;
  width: 100%;

  border: 1px solid transparent;

  &:disabled {
    background-color: $surfaceSecondary;
    color: $textSecondary;
  }

  &::placeholder {
    font-family: Noto Sans JP;
    font-size: 14px;
    font-weight: 400;
    line-height: 20.27px;
    text-align: left;

    color: $textSecondary;
  }

  &__is-error {
    border: 1px solid $semanticError;
  }

  &__label {
    display: grid;
    grid-template-columns: auto auto;
    gap: 3px;
    justify-content: space-between;
    align-items: center;

    &-text {
      padding: 8px 0;
      font-family: Noto Sans JP;
      font-size: 14px;
      font-weight: 400;
      line-height: 18.2px;
      text-align: center;

      color: $textDefault;
    }
  }
}
</style>
